var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"about"},[_c('h2',{attrs:{"id":"about"}},[_vm._v("About US")]),_c('hr'),_c('div',{staticClass:"center"},[_vm._v(" These computational models with high generalization performance have been developed by Lijia Ma's group from school of life science, Westlake university. ")])])
}]

export { render, staticRenderFns }